/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-09-30 15:47:16
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Button, Link } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { routes } from 'src/routes';
import history from 'src/routes/history';

type Props = {
  index: number,
  icon: number,
  name: number,
  appListingURL: string,
  description: string,
  instructionURL: string
};

type ComposedProps = Props & WithI18nProps;

type State = {};

class KlaviyoCard extends Component<ComposedProps, State> {
  handleToKlaviyoIntegration = () => {
    history.push(routes.integration.klaviyo.view());
  };

  render() {
    const { i18n, data = {}, index } = this.props;
    const { icon, name, appListingURL, description, instructionURL } = data;

    return (
      <div className={index === 1 ? 'item middle' : 'item'}>
        <a className="Polaris-Link" href={appListingURL} target="_blank" rel="noopener noreferrer">
          <img className="icon" src={icon} alt={i18n.translate(name)} />
        </a>

        {/* App name */}
        <div className="name">{i18n.translate(name)}</div>

        {/* App description */}
        <div className="description">{i18n.translate(description)}</div>

        <div className="btn-configure">
          <Button primary onClick={this.handleToKlaviyoIntegration}>
            {i18n.translate('AdminHTML.Integration.Integration.configure')}
          </Button>
        </div>

        {/* App instruction */}
        <div className="instruction">
          {i18n.translate('AdminHTML.Integration.Integration.instruction', {
            t: (
              <Link external url={instructionURL}>
                {i18n.translate('AdminHTML.Integration.Integration.instruction_t', {
                  nt_name: i18n.translate(name)
                })}
              </Link>
            )
          })}
        </div>
      </div>
    );
  }
}

export default withI18n()(KlaviyoCard);
